import type React from 'react';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Snackbar, SnackbarContent } from '@mui/material';

import { useGetEnv } from '@/api/util/useGetEnv.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { useVersionCheck } from './util/useVersionCheck';

export const VersionChecker: React.FC = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const { t } = useTranslationWithPrefix('components.versionChecker');
  useGetEnv();

  const handleReload = () => {
    globalThis.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={isNewVersionAvailable}
    >
      <SnackbarContent
        action={
          <Button
            color="primary"
            onClick={handleReload}
            size="small"
            startIcon={<RefreshIcon />}
            variant="contained"
          >
            {t('refresh')}
          </Button>
        }
        message={t('newVersionAvailable')}
      />
    </Snackbar>
  );
};
